import { Study } from "../../../../shared/entities/scripts/study";
import { GetDateFromString } from "../../../../shared/scripts/date-functions";
import { IGraphDataPoint } from "../../../../shared/scripts/graphing/graphing.entities";


export class ForecastGraphDataPoint implements IGraphDataPoint {
    PrimeId: number;
    StudyId: number;
    StudyIds: number[];
    Date: string;
    CumulativeCount: number;
    Count: number;
    Rate: number;
    TypeId: number; 
    IsOverall: number; //0: No, 1: Yes
    TimestampFirstDay: number;
    TimestampLastDay: number;

    PrimeContract: string;

    CountField: string;
    DayOfMonth: string;

    initialize(dayOfMonth: string = "last", countField: string = "Count"): void {

        this.PrimeContract = Study.GetStudyName(this.PrimeId);
        this.DayOfMonth = dayOfMonth;
        this.CountField = countField;
        let lastDate: Date = GetDateFromString(this.Date, "slash-month-day-year");
        this.TimestampLastDay = lastDate.getTime();

        let firstDate: Date = new Date(lastDate);
        firstDate.setDate(1);
        this.TimestampFirstDay = firstDate.getTime();
    }


    getTimestamp(): number {
        if (this.DayOfMonth == "last") { return this.TimestampLastDay; }
        else { return this.TimestampFirstDay; }
    }

    getCount(): number {
        if (this.CountField == "rate") { return this.Rate; }
        else if (this.CountField == "cumulative") { return this.CumulativeCount; }
        else { return this.Count; }

    }
}